<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-container class="toolbar__container">
      <v-form ref="form">
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-datetime-picker :label="$t('datetime.limitDate')" v-model="dtreferencia" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')" :rules="[dtReferenciaRules]">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete
              v-model="idEmpresaSelected"
              :items="empresas"
              item-text="razao_social"
              item-value="id_empresa"
              clearable
              :label="$tc('company.self', 1)"
              @change="empresasSelectChanged"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <LazySelect
              ref="linhaSelect"
              get-url="getLinhaslazy"
              :request-data="lazySelectRequestData"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              @input="onLinhaInput"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <LazySelect
              ref="veiculoSelect"
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              text="cod_veiculo"
              value="id_veiculo"
              :label="$tc('vehicle.self', 1)"
              @input="onVeiculoInput"
            />
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="2">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="6" md="2">
            <div style="display: flex; justify-content: flex-end; gap: 10px;">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="populaRelatorio">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                    @click="limparFiltros">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.newConsult') }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <merus-data-table :headers="headers" :required-headers="headersObrigatorios" :items="veiculosFiltrados" :loading="loadingVeiculos" :default-multi-sort="multiSort"
      :loading-text="$t('system.messages.loading')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="RELSTATUSVEICULOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('relStatusVehicle.title')" :token="token"
          :items="displayedItemsForExport !== null ? displayedItemsForExport : veiculosFiltrados"
          csv-title="relstatusveiculos" :csv-headers="headersComObrigatorios" :pdf-title="$t('relStatusVehicle.title')" :pdf-headers="headersComObrigatorios"
          pdf-filename="relstatusveiculos" hide-search>
        </CadastroToolbar>
      </template>

      <template v-slot:item.status_geotab_extenso="{ item }">
        <span class="status-fonte-cell">
          <span
            class="status-fonte-dot"
            :style="{ backgroundColor: statusFonteDotColor(item.status_geotab) }"
            :title="item.status_geotab_extenso"
          ></span>
          <span>{{ item.status_geotab_extenso }}</span>
        </span>
      </template>

      <template v-slot:item.status_faceid_extenso="{ item }">
        <span class="status-fonte-cell">
          <span
            class="status-fonte-dot"
            :style="{ backgroundColor: statusFaceIdDotColor(item.status_faceid) }"
            :title="item.status_faceid_extenso"
          ></span>
          <span>{{ item.status_faceid_extenso }}</span>
        </span>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import DateUtils from "../utils/dateutils";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import LazySelect from './Selects/LazySelect.vue';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
    LazySelect,
    MultiplaEscolha,
  },
  data: () => ({
    headers: [],
    displayedItemsForExport: null,
    search: "",
    user: null,
    token: null,
    timeProps: {
      useSeconds: true,
    },
    showConfirmButton: true,
    dtreferencia: null,
    form: true,
    isAtivo: true,
    loadingVeiculos: false,
    empresas: [],
    idEmpresaSelected: null,
    idLinhaSelected: null,
    idVeiculoSelected: null,
    unidadesSelecionadas: [],
    veiculos: [],
    setup: {
      has_validador: 0,
      has_queclink: 0,
      has_detro: 0,
    },
  }),
  computed: {
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.today
      }
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
    headersObrigatorios() {
      return [
        {
          text: this.$t('relStatusVehicle.headers.company'),
          value: 'razao_social',
          sortable: true,
          filtrable: true,
          show: true,
          to_export: 1,
          label: this.$t('relStatusVehicle.headers.company'),
        },
        {
          text: this.$t('relStatusVehicle.headers.line'),
          value: 'cod_linha',
          sortable: true,
          filtrable: true,
          show: true,
          to_export: 1,
          label: this.$t('relStatusVehicle.headers.line'),
        },
      ];
    },
    headersComObrigatorios() {
      const valores = new Set((this.headers || []).map((h) => h.value));
      return [
        ...this.headersObrigatorios.filter((h) => !valores.has(h.value)),
        ...(this.headers || []),
      ];
    },
    veiculosFiltrados() {
      let select = this.veiculos.filter((v) => this.passaFiltroUnidades(v));

      if (this.idEmpresaSelected) {
        select = select.filter((v) => v.id_empresa == this.idEmpresaSelected);
      }

      if (this.idLinhaSelected) {
        select = select.filter((v) => v.id_linha == this.idLinhaSelected);
      }

      if (this.idVeiculoSelected) {
        select = select.filter((v) => v.id_veiculo == this.idVeiculoSelected);
      }

      return select;
    },
    multiSort() {
      return [
        { value: 'cod_veiculo', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
    },
    unidadesSelecionadas() {
      this.displayedItemsForExport = null;
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {

    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data || [];
        },
      });
    },
    resetLazySelectRef(name) {
      const ref = this.$refs[name];
      if (ref && typeof ref.resetData === 'function') {
        ref.resetData();
      }
    },
    empresasSelectChanged() {
      this.displayedItemsForExport = null;
      this.idLinhaSelected = null;
      this.idVeiculoSelected = null;
      this.resetLazySelectRef('linhaSelect');
      this.resetLazySelectRef('veiculoSelect');
    },
    onLinhaInput(id) {
      this.displayedItemsForExport = null;
      this.idLinhaSelected = id;
      this.idVeiculoSelected = null;
      this.resetLazySelectRef('veiculoSelect');
    },
    onVeiculoInput(id) {
      this.displayedItemsForExport = null;
      this.idVeiculoSelected = id;
    },
    limparFiltros() {
      this.$refs.form.resetValidation();
      this.dtreferencia = new Date();
      this.idEmpresaSelected = null;
      this.idLinhaSelected = null;
      this.idVeiculoSelected = null;
      this.unidadesSelecionadas = [];
      this.veiculos = [];
      this.loadingVeiculos = false;
      this.displayedItemsForExport = null;
      this.search = "";
      this.resetLazySelectRef('linhaSelect');
      this.resetLazySelectRef('veiculoSelect');
      this.resetLazySelectRef('unidadesSelect');
    },
    populaRelatorio() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var dtref = DateUtils.getDateSQLFormatted(this.dtreferencia);
      this.populaVeiculos(dtref);
    },
    initialize() {
      this.dtreferencia = new Date();
      this.populaSetup();
      this.populaEmpresas();
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        silent: true,
        onSuccess: (response) => {
          this.setup = response.data[0];
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    populaVeiculos(dtref) {
      this.loadingVeiculos = true;
      apiController.request(apiController.endpoints.getStatusallveiculospordata, {
        params: { dt: dtref },
        silent: true,
        onSuccess: (response) => {
          this.veiculos = response.data || [];
          this.displayedItemsForExport = null;
          this.loadingVeiculos = false;
        },
        onError: (e) => {
          this.loadingVeiculos = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    dtReferenciaRules() {
      if (this.dtreferencia && new Date(this.dtreferencia) > new Date()) {
        return this.$t('rules.inicialBiggerThanFinalDate');
      }
      return true;
    },
    // Geotab: 0 = offline, 1 = online (null/ausente = N/A).
    statusFonteDotColor(value) {
      switch (Number(value)) {
        case 1: return '#4CAF50';
        case 0: return '#F44336';
        default: return '#9E9E9E';
      }
    },
    // FaceID (status_comunicacao_equipamentos): 1 = online, 2 = offline, 0/null = unknown/N/A.
    statusFaceIdDotColor(value) {
      switch (Number(value)) {
        case 1: return '#4CAF50';
        case 2: return '#F44336';
        default: return '#9E9E9E';
      }
    },
  },
};
</script>

<style scoped>
.status-fonte-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.status-fonte-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
